import React from 'react';
import { useNavigate } from 'react-router-dom';

const ShippingPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-lg p-6 md:p-8">
        {/* Back button */}
        <button 
          onClick={() => navigate(-1)} 
          className="mb-8 flex items-center text-[#002E62] hover:text-[#f26522] transition-colors"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          Back
        </button>

        <h1 className="text-3xl font-bold text-gray-900 mb-8 text-center">Shipping Policy</h1>

        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">1. Overview</h2>
          <p className="mb-4">
            At Surya Media ("we", "our", or "us"), we currently do not provide physical product deliveries. All our services and offerings are delivered digitally or in-person, depending on the nature of the service.
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">2. Shipping Not Applicable</h2>
          <p className="mb-4">
            Since our business model does not involve shipping of physical goods, a shipping policy is not applicable. Customers purchasing our services will receive confirmation and delivery of services through online channels (such as email, WhatsApp, or digital reports).
          </p>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">3. Service Delivery</h2>
          <ul className="list-disc pl-6 mb-4">
            <li>Digital reports are typically delivered within the committed timeframe mentioned at the time of booking.</li>
            <li>Consultations and astrology services are provided as per the scheduled appointment.</li>
            <li>Any delays will be communicated promptly to the customer.</li>
          </ul>

          <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">4. Contact Us</h2>
          <p className="mb-4">
            If you have any questions regarding service delivery, please contact us:
          </p>
          <p className="mb-4">
            Surya Media<br />
            Madhapur, Hyderabad, Telangana 500018<br />
            Email: suryamedia54@gmail.com<br />
            Phone: +91 81859 22222
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
